import { Component } from '@angular/core';

@Component({
  selector: 'no-content',
  template: `
    <div>
      <h1 style="color: white;">404: page missing</h1>
      <a [routerLink]="['']">Go To Home</a>
    </div>
  `
})
export class NoContentComponent {

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/no-content/no-content.component.ts